export const currencies = [
    {
        value: 'stx',
        label: 'Stacks',
        icon: '/32-stx.png',
        ftaddress: 'stacks',
        contractName: 'stacks',
        decimalfactor: 1000000
    },
    {
        value: 'cc',
        label: 'CryptoCash',
        icon: '/32-cc.png',
        ftaddress: 'SP7MKPEA5DVQQ1PQNYPC1P5YRF14CY3CWZF70R01.cryptocash-token::CC',
        contractName: 'SP7MKPEA5DVQQ1PQNYPC1P5YRF14CY3CWZF70R01.cryptocash-token',
        decimalfactor: 1
    },
    // {
    //     value: 'cc',
    //     label: 'CryptoCash',
    //     icon: '/32-cc.png',
    //     ftaddress: 'ST1ZK0A249B4SWAHVXD70R13P6B5HNKZAA0WNTJTR.cryptocash-token::cryptocash',
    //     contractName: 'ST1ZK0A249B4SWAHVXD70R13P6B5HNKZAA0WNTJTR.cryptocash-token',
    //     decimalfactor: 1
    // },
    // {
    //     value: 'mia',
    //     label: 'MiamiCoin',
    //     icon: '/32-mia.png',
    //     ftaddress: 'SP1H1733V5MZ3SZ9XRW9FKYGEZT0JDGEB8Y634C7R.miamicoin-token-v2::miamicoin',
    //     contractName: 'SP1H1733V5MZ3SZ9XRW9FKYGEZT0JDGEB8Y634C7R.miamicoin-token-v2',
    //     decimalfactor: 1000000
    // },
    // {
    //     value: 'nyc',
    //     label: 'NewYorkCityCoin',
    //     icon: '/32-nyc.png',
    //     ftaddress: 'SPSCWDV3RKV5ZRN1FQD84YE1NQFEDJ9R1F4DYQ11.newyorkcitycoin-token-v2::newyorkcitycoin',
    //     contractName: 'SPSCWDV3RKV5ZRN1FQD84YE1NQFEDJ9R1F4DYQ11.newyorkcitycoin-token-v2',
    //     decimalfactor: 1000000
    // },
    // {
    //     value: 'diko',
    //     label: 'Arkadiko',
    //     icon: '/32-diko.png',
    //     ftaddress: 'SP2C2YFP12AJZB4MABJBAJ55XECVS7E4PMMZ89YZR.arkadiko-token::diko',
    //     contractName: 'SP2C2YFP12AJZB4MABJBAJ55XECVS7E4PMMZ89YZR.arkadiko-token',
    //     decimalfactor: 1000000
    // },
    // {
    //     value: 'gift',
    //     label: 'Gift',
    //     icon: '/32-gift.png',
    //     ftaddress: 'SP3T3JC6V4S94PPB7WFEK17863HPG3EYP6CJ65E7M.derupt-gift::gift',
    //     contractName: 'SP3T3JC6V4S94PPB7WFEK17863HPG3EYP6CJ65E7M.derupt-gift',
    //     decimalfactor: 1
    // },
    // {
    //     value: 'xbtc',
    //     label: 'xBTC',
    //     icon: '/32-xbtc.png',
    //     ftaddress: 'SP3DX3H4FEYZJZ586MFBS25ZW3HZDMEW92260R2PR.Wrapped-Bitcoin::wrapped-bitcoin',
    //     contractName: 'SP3DX3H4FEYZJZ586MFBS25ZW3HZDMEW92260R2PR.Wrapped-Bitcoin',
    //     decimalfactor: 100000000
    // }
];

export const cryptoCash = [
    {
        coinId: 1,
        label: 'CryptoCash',
        icon: '/32-cc.png',
        coinName: 'cc',
        contractName: 'SP7MKPEA5DVQQ1PQNYPC1P5YRF14CY3CWZF70R01.cryptocash-token',
        assetId: 'SP7MKPEA5DVQQ1PQNYPC1P5YRF14CY3CWZF70R01.cryptocash-token::CC',
        colorScheme1: "linear-gradient(to left, #F7931A , #6444fe)",
        colorScheme2: "linear-gradient(to right, #F7931A , #6444fe)"
    }
];

// export const cityCoins = [
//     {
//         cityId: 1,
//         label: 'Miamicoin',
//         icon: '/32-mia.png',
//         cityName: 'mia',
//         contractName: 'SP1H1733V5MZ3SZ9XRW9FKYGEZT0JDGEB8Y634C7R.miamicoin-token-v2',
//         assetId: 'SP1H1733V5MZ3SZ9XRW9FKYGEZT0JDGEB8Y634C7R.miamicoin-token-v2::miamicoin',
//         colorScheme1: "linear-gradient(to left, #b94a97 , #319fc5)",
//         colorScheme2: "linear-gradient(to right, #b94a97 , #319fc5)"
//     },
//     {
//         cityId: 2,
//         label: 'Newyorkcitycoin',
//         icon: '/32-nyc.png',
//         cityName: 'nyc',
//         contractName: 'SPSCWDV3RKV5ZRN1FQD84YE1NQFEDJ9R1F4DYQ11.newyorkcitycoin-token-v2',
//         assetId: 'SPSCWDV3RKV5ZRN1FQD84YE1NQFEDJ9R1F4DYQ11.newyorkcitycoin-token-v2::newyorkcitycoins',
//         colorScheme1: "linear-gradient(to left, #e9ae09, #b7282a)",
//         colorScheme2: "linear-gradient(to right, #e9ae09, #b7282a)"
//     },
// ];